/**
 * @file コンポーネント：フル動画ページシェーマポップアップ スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledPopup = styled.div``;

export const StyledSliderImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;
